<template>
    <div name="settlement-file-view" class="wrapper">
        <div class="page">
            <div class="button-header">
                <img @click="back" style="width: 26px; cursor: pointer;" src="../../../assets/medical_back_icon.png" />
            </div>
            <!-- <embed
                v-if="pdfSrc !== null"
                :src="pdfSrc"
                type="application/pdf"
                style="width: 100%; height: 100vh;"
            /> -->
            <pdf v-if="loadingTask" :src="loadingTask" style="display: none" @num-pages="onNumPages"></pdf>
            <div v-if="numPages" style="width: 100%;">
                <div
                    v-for="page in numPages"
                        :key="page"
                        style="width: 100%"
                    >
                    <pdf
                        :src="loadingTask"
                        :page="page"
                        style="width: 100%"
                    />
                </div>
                </div>
                        
            <div class="bottom-button-box" >
                <bottom-button 
                    :text="'이 서류 저장하기'"
                    :color="'var(--Gray-100, #1E1E1E)'"
                    @onClick="downloadDoc2"
                />
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios';
import pdf from "vue-pdf";
import BottomButton from '@/components/atoms/BottomButton';
export default {
    name: 'settlementFileView',
    props: ['settlement'],
    components: {
        pdf,
        BottomButton
    },
    data: function()
    {
        return {
            pdfSrc: null,
            numPages: 0,
            loadingTask: null
        }
    },
    created: function()
    {
        this.loadingTask = pdf.createLoadingTask(this.settlement.document_url)
    },
    mounted: function() {
        // axios.get(this.settlement.document_url, {
        //     responseType: "blob"
        // }).then(res => {
        //     const blob = new Blob([res.data], { type: "application/pdf" });
        //     this.pdfSrc = URL.createObjectURL(blob);
        // });
    },
    methods: {
        back: function()
        {
            this.$emit('closeFileView')
        },
        onNumPages: function(n)
        {
            if(n !== undefined)
            {
                this.numPages = n;
            }
        },
        downloadDoc2: async function()
        {
            const fileName = `${this.settlement.name}(${this.settlement.birth})_${this.settlement.year}년도자료_(의료기기구입).pdf`;

            // 솔닥 앱(nachocode) 웹뷰에서는 a.click() 다운로드가 먹통되는 이슈가 있어
            // Web Share API(네이티브 공유 시트 → 저장)로 처리
            if (navigator.userAgent.toLowerCase().includes('nachocode')) {
                try {
                    const resp = await fetch(this.settlement.document_url);
                    const blob = await resp.blob();
                    const file = new File([blob], fileName, { type: blob.type || 'application/pdf' });
                    if (navigator.share && navigator.canShare && navigator.canShare({ files: [file] })) {
                        await navigator.share({ files: [file], title: fileName });
                    } else {
                        window.location.href = this.settlement.document_url;
                    }
                } catch (err) {
                    // 사용자가 공유 시트를 취소한 경우(AbortError)는 무시
                    if (!err || err.name !== 'AbortError') {
                        window.location.href = this.settlement.document_url;
                    }
                }
                return;
            }

            // 카카오톡 인앱 브라우저(안드로이드/iOS)는 blob: URL 다운로드를 지원하지 않아("지원하지 않는 파일 형식입니다")
            // 서버 GET 다운로드 URL(Content-Disposition: attachment)로 직접 이동
            if (navigator.userAgent.includes('KAKAOTALK')) {
                window.location.href = `${process.env.API_DB_ROOT}/download/uploadfiles?fileUrl=${encodeURIComponent(encodeURI(this.settlement.document_url))}&fileName=${encodeURIComponent(fileName)}`;
                return;
            }

            let blob;
            let filename = fileName;
            try {
                const res = await axios.post(
                    `${process.env.API_DB_ROOT}/download/uploadfiles`,
                    { fileUrl: encodeURI(this.settlement.document_url), fileName },
                    { responseType: 'blob' }
                );
                const disposition = res.headers['content-disposition'] || '';
                const match = disposition.match(/filename="?([^"]+)"?/);
                if (match) filename = decodeURIComponent(match[1]);
                blob = res.data;
            } catch (e) {
                // 다운로드 서버 실패 시 CDN(CloudFront, CORS 허용)에서 직접 받아 저장
                try {
                    const resp = await fetch(this.settlement.document_url);
                    if (!resp.ok) throw new Error(`HTTP ${resp.status}`);
                    blob = await resp.blob();
                } catch (err) {
                    alert('다운로드에 실패했습니다. 잠시 후 다시 시도해주세요.');
                    return;
                }
            }

            const blobUrl = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = blobUrl;
            a.download = filename;
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
            window.URL.revokeObjectURL(blobUrl);
        },
        downloadDoc: function()
        {

            if (navigator.userAgent.includes('NAVER')) {

                alert('네이버 앱을 통해 접속 시 문서 다운로드가 원활하지 않을 수 있습니다. \n다운로드가 되지 않을 경우, 크롬이나 삼성인터넷 등 다른 브라우저를 이용 부탁드립니다.');

                if (navigator.userAgent.includes('Android')) {
                   
                    
                    this.onSaveAs(this.settlement.document_url)
                   
                    return;
                } 

                let file_name = "file";         
                file_name = `${this.settlement.name}(${this.settlement.birth})_${this.settlement.year}년도자료_(의료기기구입).pdf`
            

                // axios.get(this.settlement.document_url, {
                //     responseType: "blob"
                // }).then(res => {
                //     const blob = new Blob([res.data], { type: "application/pdf" });
                //     this.pdfSrc = URL.createObjectURL(blob);

                //     const a = document.createElement('a');
                //     a.href = this.pdfSrc;
                //     a.download = file_name;
                //     document.body.appendChild(a);
                //     a.click();
                //     document.body.removeChild(a);
                //     window.URL.revokeObjectURL(this.pdfSrc);

                // });


                fetch(this.settlement.document_url)
                .then(res => res.blob())
                .then(blob => {
                    const url = window.URL.createObjectURL(blob);
                    const a = document.createElement('a');
                    a.href = url;
                    a.download = file_name;
                    document.body.appendChild(a);
                    a.click();
                    document.body.removeChild(a);
                    window.URL.revokeObjectURL(url);
                });
                return;
            }
            else if(navigator.userAgent.includes('KAKAO'))
            {
                this.onSaveAs(this.settlement.document_url)
            }
            else
            {
                axios.get(this.settlement.document_url, {
                    responseType: "blob"
                }).then(res => {
                    const blob = new Blob([res.data], { type: "application/pdf" });
                    this.pdfSrc = URL.createObjectURL(blob);

                    const a = document.createElement('a');
                    a.href = this.pdfSrc;
                    a.download = `${this.settlement.name}(${this.settlement.birth})_${this.settlement.year}년도자료_(의료기기구입).pdf`;
                    document.body.appendChild(a);
                    a.click();
                    document.body.removeChild(a);
                    window.URL.revokeObjectURL(this.pdfSrc);

                });
            }
           
        },
        onSaveAs: async function(uri) {
            const fileName = `${this.settlement.name}(${this.settlement.birth})_${this.settlement.year}년도자료_(의료기기구입).pdf`;
            // 솔닥 앱(nachocode) 웹뷰에서는 a.click() 다운로드가 먹통되는 이슈가 있어
            // Web Share API(네이티브 공유 시트 → 저장)로 처리
            if (navigator.userAgent.toLowerCase().includes('nachocode')) {
                try {
                    const resp = await fetch(uri);
                    const blob = await resp.blob();
                    const file = new File([blob], fileName, { type: blob.type || 'application/pdf' });
                    if (navigator.share && navigator.canShare && navigator.canShare({ files: [file] })) {
                        await navigator.share({ files: [file], title: fileName });
                    } else {
                        window.location.href = uri;
                    }
                } catch (err) {
                    if (!err || err.name !== 'AbortError') {
                        window.location.href = uri;
                    }
                }
                return;
            }

            var link = document.createElement('a');
            document.body.appendChild(link);
            link.href = uri;
            link.download= `${this.settlement.name}(${this.settlement.birth})_${this.settlement.year}년도자료_(의료기기구입).pdf`;
            link.click();
            document.body.removeChild(link);
        },
    }
}
</script>

<style scoped>
    .wrapper {
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;

    }
    .page {
        width: 100%;
        background: #FFF;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: flex-start;
        box-sizing: border-box;
        padding: 0 16px;
        overflow: hidden;
        padding-bottom: 100px;
    }

    @media (min-width: 600px) {
        .page {
            width: 600px;
        }
    }

    .button-header {
        width: 100%;
        height: 49px;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        box-sizing: border-box;
    }
    .bottom-button-box {
        width: calc(100% - 32px);
        position: fixed;
        bottom: 28px;
        max-width: 568px;
    }
</style>


// WEBPACK FOOTER //
// src/components/organisms/contract/SettlementFileView.vue